import React from 'react';
export function SplitIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.707 14.293a1 1 0 00-1.414 1.414L18.586 17h-3.253a6.982 6.982 0 01-6.462-4.307L8.583 12l.288-.693A6.982 6.982 0 0115.333 7h3.253l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 00-1.414 1.414L18.586 5h-3.253a8.977 8.977 0 00-8.308 5.54l-.192.46H3a1 1 0 000 2h3.833l.192.462A8.977 8.977 0 0015.333 19h3.253l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3z"
  }));
}